
class HomeSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
			autoPlay: true,
			pageDots: true,
			wrapAround: true,
			prevNextButtons: false,
			freeScroll: true,
			cellSelector: ".slide",
			cellAlign: "center",
		};


		if (this.$el.length) {
			this._createSlider();
		}
	}

	_createSlider() {
		this.$el.flickity(this.options);
	}
}

export default HomeSlider;
